import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { MarginProps } from '../../../../../theme/styledProps';
import { SectionHeader } from '../SectionHeader/SectionHeader';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Toggle } from '../../../../../CommonComponents/OPL/Toggle/Toggle';
import { FormFieldName as FirmFormFieldName } from '../../FirmSettings.meta';
import { FormFieldName as MySettingsFormFieldName } from '../../../MySettings/MySettings.meta';

interface Props extends MarginProps {
  isFirm?: boolean;
  fieldName: FirmFormFieldName | MySettingsFormFieldName;
  formBag: UseFormReturn<any>;
}

export const ManualAccounts: React.FC<Props> = ({
  formBag,
  isFirm = false,
  fieldName,
  ...rest
}) => {
  return (
    <Box as="section" {...rest}>
      <SectionHeader title="Ability to Add Manual Accounts" />

      <Toggle {...formBag.register(fieldName)}>Allow the ability to add manual accounts</Toggle>

      {isFirm && (
        <Toggle {...formBag.register('allowAdviserOverrideAddManualAccount')} mt={32}>
          Allow advisors to override the ability to add manual accounts
        </Toggle>
      )}
    </Box>
  );
};
